export default __webpack_public_path__ + "static/media/ic_ecuador.e4a505b3.svg";